import {
  SPORT_FIELD_LIST,
  BOOKING_CALENDAR_LINK,
  MAINTENANCE_TITLE,
  CONDITION,
  EXCEPTION_NOTIFICATION,
  CONTACT_INFORMATION_TITLE,
  STREET_ADDRESS,
  SPACER,
  CITY,
  POSTAL_CODE,
  PROPERTIES_TITLE,
  DESCRIPTION_TITLE,
  DESCRIPTION
 } from '../elements.template'

const LAYOUT = {
  type: 'padel',
  layout: [
    [
      // Start left column
      DESCRIPTION_TITLE,
      DESCRIPTION,
      PROPERTIES_TITLE,
      SPORT_FIELD_LIST,
      { ...BOOKING_CALENDAR_LINK, style: { flex: 1, maxWidth: '38rem' } }
      // End left column
    ],
    [
      // Start right column
      MAINTENANCE_TITLE,
      { ...CONDITION, style: { flex: 1, maxWidth: '24rem' } },
      EXCEPTION_NOTIFICATION,
      CONTACT_INFORMATION_TITLE,
      {
        type: 'container',
        className: 'customRowFixed',
        style: { paddingBottom: '10rem' },
        items: [
          STREET_ADDRESS,
          SPACER,
          CITY,
          SPACER,
          POSTAL_CODE
        ]
      }
      // End right column
    ]
  ]
}

export default LAYOUT
